// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"mfa-qr-code__wrapper--2o5u9","continue":"mfa-qr-code__continue--3RHlp"};